import { CardInfo, CardSuit, CardValue } from "../../interface/game";

export function sortedFullDeck(): CardInfo[] {
    return Object.values(CardSuit).map(
        (suit) => Object.values(CardValue).map(
            (value) => ({ suit, value })
        )
    ).flat();
}

// Fisher-Yates shuffle
export function shuffle<T>(array: T[]): T[] {
    const shuffled = [...array];
    for (let i = array.length - 1; i > 0; i--) {
      let j = Math.floor(Math.random() * (i + 1)); // random index from 0 to i
      [shuffled[i], shuffled[j]] = [shuffled[j], shuffled[i]];
    }
    return shuffled;
}